/**
 * Static brand metadata. Media assets (founder photo/video, dashboard
 * screenshots, testimonial videos, case study images, PDFs) are managed
 * through Admin → Assets and stored in the `site_assets` table, not here.
 */

export const FOUNDER_NAME = "Elevate Global Solutions Leadership";
export const FOUNDER_TITLE = "Founder & CEO";
export const FOUNDER_LINKEDIN_URL =
  "https://www.linkedin.com/company/elevate-global-solutions-egypt";
